import React from 'react';
import { UnderUtvikling } from './practiceplaces';

const ContactPersonsPage = () => <UnderUtvikling />;

export default ContactPersonsPage;
